"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryField = void 0;
var _react = _interopRequireDefault(require("react"));
var _Localization = require("../../../Localization");
var _constants = require("../../../constants");
var _defaultTranslations = require("../../../constants/defaultTranslations");
var _TranslationKey = require("../../../models/TranslationKey");
var _SelectFormFieldByConfig = require("../SelectFormFieldByConfig");
var _ToggleFieldByConfig = require("../ToggleFieldByConfig");
var _jsxRuntime = require("react/jsx-runtime");
const CountryField = props => {
  const {
    initialValue,
    availableOptions = [],
    isAvailable,
    isEditable,
    isEnabledSearch,
    validation
  } = props;
  const label = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
    defaultMessage: _defaultTranslations.defaultTranslations.country,
    id: _TranslationKey.TranslationKey.country
  });
  const isMatchRequired = validation?.isAddressMatchRequired;
  if (!isAvailable) {
    return null;
  }
  const selectOptions = availableOptions.map(item => ({
    label: item,
    value: item
  }));
  const sortedSelectOptions = selectOptions.sort((a, b) => a.label.localeCompare(b.label));
  const showComponent = isEditable && isEnabledSearch;
  const initialValueItem = initialValue ?? availableOptions[0];
  const countryFieldConfig = {
    ToggleFieldByConfig: {
      condition: showComponent && availableOptions.length === 2,
      props: {
        ...props,
        options: availableOptions
      }
    },
    SelectFormFieldByConfig: {
      condition: showComponent && availableOptions.length > 2,
      props: {
        ...props,
        options: sortedSelectOptions,
        initialValue: initialValueItem
      }
    },
    TextFormFieldByConfig: {
      condition: !showComponent,
      props: {
        ...props
      }
    }
  };
  const selectCountryComponent = Object.entries(countryFieldConfig).filter(([_, config]) => config.condition).map(([ComponentName, {
    props: componentProps
  }]) => {
    const Component = ComponentName === 'ToggleFieldByConfig' ? _ToggleFieldByConfig.ToggleFieldByConfig : _SelectFormFieldByConfig.SelectFormFieldByConfig;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      name: _constants.NAMES.COUNTRY,
      label: label,
      isAddressMatchRequired: isMatchRequired,
      ...componentProps
    }, ComponentName);
  });
  return selectCountryComponent;
};
exports.CountryField = CountryField;
//# sourceMappingURL=CountryField.js.map